import { render, staticRenderFns } from "./NewsSource.vue?vue&type=template&id=c5d7ec6e&"
import script from "./NewsSource.vue?vue&type=script&lang=js&"
export * from "./NewsSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports